import React from "react";
import { BiPlus } from "react-icons/bi";
import { useTranslation } from "react-i18next";

interface CreateFieldPromptProps {
  onCreateField: () => void;
  title?: string;
  subtitle?: string;
}

export const CreateFieldPrompt: React.FC<CreateFieldPromptProps> = ({
  onCreateField,
  title,
  subtitle,
}) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <button
        onClick={onCreateField}
        className="group flex w-full flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-gray-300 bg-white p-10 text-center transition-colors hover:border-blue-400 hover:bg-blue-50"
      >
        <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-500 transition-colors group-hover:border-blue-400 group-hover:text-blue-600">
          <BiPlus size={24} />
        </span>
        <span className="text-lg font-semibold text-gray-900">
          {title || t("common.addField")}
        </span>
        <span className="text-sm text-gray-500">
          {subtitle || t("common.createFirstField")}
        </span>
      </button>
    </div>
  );
};

export default CreateFieldPrompt;
